// @flow
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Spinner,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { RenewalOfferContext } from '../context';
import messages from '../messages';
import PreviousOffersDetails from '../PreviousOffersDetails';

const PreviousOffersSection = () => {
  const { leaseId, isLoadingOffers, previousOffers } =
    useContext(RenewalOfferContext);

  return (
    <>
      <Typography variant="titleMedium">
        <strong>
          <FormattedMessage {...messages.previousOffers} />
        </strong>
      </Typography>

      {leaseId ? (
        isLoadingOffers ? (
          <Spinner />
        ) : previousOffers.length > 0 ? (
          previousOffers.map((offer, i) => (
            <PreviousOffersDetails
              key={`${offer.offerDate}_${i}`}
              offer={offer}
            />
          ))
        ) : (
          <Typography variant="bodyMedium">
            <FormattedMessage {...messages.zeroPreviousRenewalOffers} />
          </Typography>
        )
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default PreviousOffersSection;
